import { z } from 'zod'
import { UpsertContentInputZ } from '@/backend/modules/content/external-functions/mutations/upsert-content/input'

export const UpsertJobOfferInputDTOZ = z.object({
  id: z.string().uuid().optional(),

  positionName: z.string().min(1, 'Nazwa stanowiska jest wymagana'),
  isActive: z.boolean(),
  description: z.string().min(1, 'Opis jest wymagany'),
  recruitmentProcess: z
    .array(
      z.object({
        step: z.string().min(1),
        description: z.string().min(1),
        order: z.number(),
        openFrom: z.date().optional(),
        openTo: z.date().optional()
      })
    )
    .optional(),
  markdownAndAttachments: UpsertContentInputZ,

  salary: z
    .object({
      uop: z.string().nullable().optional(),
      b2b: z.string().nullable().optional(),
      uz: z.string().nullable().optional()
    })
    .refine(
      data => {
        return (
          (data.uop ?? '').trim() !== '' ||
          (data.b2b ?? '').trim() !== '' ||
          (data.uz ?? '').trim() !== ''
        )
      },
      {
        message: 'Co najmniej jedna stawka jest wymagana',
        path: ['salary']
      }
    )
})
export type UpsertJobOfferInputDTO = z.infer<typeof UpsertJobOfferInputDTOZ>
